import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "checkmark"]

  connect() {
    // Initialize checkbox state
    this.updateCheckmark()
  }

  toggle() {
    this.updateCheckmark()
  }

  updateCheckmark() {
    const checkbox = this.checkboxTarget
    const checkmark = this.checkmarkTarget

    if (checkbox.checked) {
      checkmark.classList.remove("opacity-0")
      checkmark.classList.add("opacity-100")
    } else {
      checkmark.classList.remove("opacity-100")
      checkmark.classList.add("opacity-0")
    }
  }
}
